import React from 'react'
import styled from 'styled-components'
import cn from 'classnames'

import { theme } from '../../lib/theme'

interface IconButtonProps extends React.ComponentPropsWithRef<'button'> {
    children: React.ReactNode
    type?: 'button'
    dataTestId?: string
    color?: string
}

const SIconButton = styled.button`
    background-color: transparent;
    border: none;
    color: ${({ color, theme }) => color ?? theme.brandColors.CA_Mid_Gray};
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.sizing.margin.s};
    transition: ${({ theme }) => `background-color ${theme.transition}`};
    color: ${({ theme }) => theme.brandColors.CA_Mid_Gray};

    &:hover {
        color: ${({ theme }) => theme.brandColors.CA_Black};
        background-color: rgba(0, 0, 0, 0.05);
    }
`

export const IconButton = ({
    children,
    className,
    color = theme.font.darkestColor,
    dataTestId = 'icon-button',
    ...props
}: IconButtonProps): React.ReactElement => {
    return (
        <SIconButton
            {...(className && { className: cn(className) })}
            type="button"
            color={color}
            data-testid={dataTestId}
            {...props}
        >
            {children}
        </SIconButton>
    )
}
